import { render, staticRenderFns } from "./GeneralJobInputs.vue?vue&type=template&id=235bed75&"
import script from "./GeneralJobInputs.vue?vue&type=script&lang=js&"
export * from "./GeneralJobInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports